var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.tags),function(tag,index){return _c('div',{key:index,staticClass:"d-flex"},[_c('Tag',{attrs:{"text":tag,"small":_vm.small}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }